import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux'
import thunk from 'redux-thunk'
import Root from './components/Root';
import rootReducer from './redux'
import { restoreAuthState } from './redux/actions/authActions';
import 'moment/locale/es-mx'

global.moment = require('moment')
global.moment.locale('es-mx')

const store = createStore(rootReducer, {}, applyMiddleware(thunk))

store.dispatch(restoreAuthState())

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>,
  document.getElementById('root')
);
